export enum SchoolSettingKey {
  ABSENCE_FOR_DAY_OFF = "ABSENCE_FOR_DAY_OFF",
  CONSULT_ATTRIBUTION_BY_TEACHER = "CONSULT_ATTRIBUTION_BY_TEACHER",
  CONSULT_SCHOOL_REPORT_BY_PARENT = "CONSULT_SCHOOL_REPORT_BY_PARENT",
  MAX_WRITTEN_REASON_JUSTIFICATION_FOR_LEGAL_ABSENCE = "MAX_WRITTEN_REASON_JUSTIFICATION_FOR_LEGAL_ABSENCE",
  AVERAGE_WITH_ALL_EVALUATIONS_FOR_SCORE_BOOK = "AVERAGE_WITH_ALL_EVALUATIONS_FOR_SCORE_BOOK",
  CONSULT_ABSENCES_BY_PARENTS = "CONSULT_ABSENCES_BY_PARENTS",
  CONSULT_ABSENCES_BY_STUDENTS = "CONSULT_ABSENCES_BY_STUDENTS",
  CERTIFICATION_PER_UNIT_HIDDEN_IN_WEB_APP = "CERTIFICATION_PER_UNIT_HIDDEN_IN_WEB_APP",
  MENU_CONSULT_HIDDEN_IN_WEB_APP = "MENU_CONSULT_HIDDEN_IN_WEB_APP",
  MENU_COMMUNICATION_HIDDEN_IN_WEB_APP = "MENU_COMMUNICATION_HIDDEN_IN_WEB_APP",
  MENU_STUDIES_HIDDEN_IN_WEB_APP = "MENU_STUDIES_HIDDEN_IN_WEB_APP",
  MENU_PARENT_MEETING_HIDDEN_IN_WEB_APP = "MENU_PARENT_MEETING_HIDDEN_IN_WEB_APP",
  MENU_DISCIPLINE_HIDDEN_IN_WEB_APP = "MENU_DISCIPLINE_HIDDEN_IN_WEB_APP",
  MENU_STATISTICS_HIDDEN_IN_WEB_APP = "MENU_STATISTICS_HIDDEN_IN_WEB_APP",
  MENU_COLLABORATIVE_WORK_HIDDEN_IN_WEB_APP = "MENU_COLLABORATIVE_WORK_HIDDEN_IN_WEB_APP",
  MENU_PARENT_REMARKS_HIDDEN_IN_WEB_APP = "MENU_PARENT_REMARKS_HIDDEN_IN_WEB_APP",
  MENU_STUDENT_REMARKS_HIDDEN_IN_WEB_APP = "MENU_STUDENT_REMARKS_HIDDEN_IN_WEB_APP",
  ATTENDANCE_REGISTRY_PIVOT_DATE_FOR_STUDENT_ORDER = "ATTENDANCE_REGISTRY_PIVOT_DATE_FOR_STUDENT_ORDER",
  ABSENCE_JUSTIFICATION_VALIDATION_ENABLED = "ABSENCE_JUSTIFICATION_VALIDATION_ENABLED"
}
